import { jsx, jsxs } from "react/jsx-runtime";
import { Slider, Stack, Typography } from "@mui/material";
function ActionOpacities(props) {
  const { palette, createOpacitySetter, colorId } = props;
  const onChange = (_, value) => {
    const val = Array.isArray(value) ? value[0] : value;
    createOpacitySetter(colorId)(val);
  };
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: 1, children: [
    /* @__PURE__ */ jsx(Typography, { children: titlesByColorId[colorId] ?? colorId }),
    /* @__PURE__ */ jsx(
      Slider,
      {
        max: 1,
        min: 0,
        onChange,
        size: "small",
        step: 0.01,
        value: getValue(colorId, palette),
        valueLabelDisplay: "auto"
      }
    )
  ] });
}
const titlesByColorId = {
  active: "Activated Opacity",
  disabled: "Disabled Opacity",
  focus: "Focus Opacity",
  hover: "Hover Opacity",
  selected: "Selected Opacity"
};
function getValue(colorId, palette) {
  switch (colorId) {
    case "active":
      return palette.action.activatedOpacity;
    case "disabled":
      return palette.action.disabledOpacity;
    case "focus":
      return palette.action.focusOpacity;
    case "hover":
      return palette.action.hoverOpacity;
    case "selected":
      return palette.action.selectedOpacity;
    default:
      console.warn("Unmanaged colorId in getValue function. Please check the colorId passed to the function.");
      return 0;
  }
}
export {
  ActionOpacities
};
//# sourceMappingURL=ActionOpacities.js.map
